import { useContext, useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { AppContext } from "../../Context/AppContext";
import { useHistory } from "react-router-dom";
import { Modal } from "semantic-ui-react";
import CMP_SESSION_TIMEOUT from "../cmp-session-timeout/cmp-session-timeout";

function IdleTimerContainer() {
  /* VARIABLE DECLARATIONS
    ---------------------------------------------------------------------------------*/

  const {
    selectedBuilding,
    cartItems,
    checkedUnitsData,
    selected_units,
    defaultPane,
    orderFilter,
    sbuildingData,
    bInfo,
    userInfo,
    sliderCart,
    isUserImpersonated,
    impersonatedUser,
  } = useContext(AppContext);
  const [, setIsImpersonatedUser] = impersonatedUser;
  const [, setSelectedBuilding] = selectedBuilding;
  const [, setSingleBuildingData] = sbuildingData;
  const [, setCartItems] = cartItems;
  const [, setCheckedUnits] = checkedUnitsData;
  const [, set_add_unit] = selected_units;
  const [, set_default_pane] = defaultPane;
  const [, set_order_filter] = orderFilter;
  const [, setBuildingInfo] = bInfo;
  const [user, setUser] = userInfo;
  const [, setSideSliderCart] = sliderCart;
  const [impersonated, setImpersonated] = isUserImpersonated;
  const [mdl_session_timeout_open, set_mdl_session_timeout_open] =
    useState(false);

  const history = useHistory();

  /* EVENT FUNCTIONS
    ---------------------------------------------------------------------------------*/
  const handleLogout = () => {
    if (user.role === "customer" && impersonated) {
      history.replace("/scheduler");
      localStorage.clear();
    } else if (user.role === "customer") {
      history.replace("/");
      localStorage.clear();
    } else {
      history.replace("/scheduler");
    }

    localStorage.removeItem("user");
    localStorage.removeItem("all_pest_list");
    localStorage.removeItem("pest_list");
    localStorage.removeItem("s_id");
    localStorage.removeItem("scheduler_user");
    localStorage.removeItem("building");
    localStorage.removeItem("impersonation");
    localStorage.clear();
    sessionStorage.clear();
    setBuildingInfo(null);
    setSelectedBuilding(null);
    setSingleBuildingData([]);
    setCartItems(null);
    setCheckedUnits({});
    set_default_pane(0);
    set_order_filter(3);
    set_add_unit([{ unit_number: "", followup: false, key: 0 }]);
    setSideSliderCart(false);
  };

  const { reset, pause, resume } = useIdleTimer({
    timeout: 1000 * 60 * 60, // 60 minutes
    startOnMount: false,
    debounce: 500,
    onIdle: () => {
      set_mdl_session_timeout_open(true);
      handleLogout();
    },
  });

  const handleCloseModal = () => {
    set_mdl_session_timeout_open(false);

    setUser(null);
    setImpersonated(false);
    setIsImpersonatedUser(false);
    // window.location.reload();
  };

  /* EVENT LISTENERS
    ---------------------------------------------------------------------------------*/
  useEffect(() => {
    if (!user) return;

    // Initial state on mount
    if (document.visibilityState === "visible") {
      reset();
      pause();
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        reset();
        pause();
      } else {
        resume();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [user, reset, pause, resume]);

  /* RENDER APP
    ---------------------------------------------------------------------------------*/
  return (
    <>
      {/***** MODAL: UPDATE SCHEDULER **************************************************************************/}
      <Modal
        id="mdl-update-scheduler"
        style={{ overflow: "visible" }}
        dimmer={"inverted"}
        open={mdl_session_timeout_open}
        onClose={() => handleCloseModal()}
      >
        <CMP_SESSION_TIMEOUT
          set_mdl_open={set_mdl_session_timeout_open}
          var_message={
            "Your session has expired due to inactivity. Please login again to continue."
          }
          var_modaltitle={"Session Timeout"}
          confirmation_function={handleCloseModal}
        ></CMP_SESSION_TIMEOUT>
      </Modal>
      {/***** END MODAL: UPDATE SCHEDULER **************************************************************************/}
    </>
  );
}

export default IdleTimerContainer;
